module.exports = "a{\n  text-decoration: none !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-error/dialog-error.component.css
// module id = ./src/app/dialog-error/dialog-error.component.css
// module chunks = main